/**
 * Conversion PDP — UGC reviews
 *
 * The review popup is driven entirely by a checkbox and CSS, so it opens and
 * closes without any script. This adds one thing the CSS cannot: Escape to
 * close, which people expect of anything modal.
 *
 * Nothing here is required for the feature to work.
 */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const open = document.querySelectorAll('.cpugc__toggle:checked');
  if (!open.length) return;

  for (const toggle of open) toggle.checked = false;
});
